import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Backdrop from './Backdrop';
import classes from './Modal.module.css';
import Button from '../UI/Button';
import Card from './Card';

const Overlay = (props) => {
  let [style, setStyle] = useState(`${classes.modal} ${classes.entry}`);

  const onButtonClicked = () => {
    props.onClick();
    setStyle(`${classes.modal} ${classes.exit}`);
  };
  console.log(style);
  return (
    <Card className={style}>
      <div>{props.msg}</div>
      <Button onClick={onButtonClicked} className={classes.btn}>
        Cool
      </Button>
    </Card>
  );
};

const Modal = (props) => {
  return (
    <div>
      {ReactDOM.createPortal(
        <Backdrop />,
        document.getElementById('modal-backdrop')
      )}
      {ReactDOM.createPortal(
        <Overlay msg={props.msg} onClick={props.onClick} />,
        document.getElementById('modal-overlay')
      )}
    </div>
  );
};

export default Modal;
